import { pickMetrics, pickPeriods } from "@/grid/config/catalog";
import type { DepartmentDefinition } from "@/grid/core/types";

const SALES_THRESHOLDS = { green: 99, yellow: 60 } as const;
const SALES_PERIOD_WEIGHTS = {
  wtd: 1,
  lastWeek: 1,
  mtd: 1.5,
  qtd: 3,
} as const;

export const salesDepartment: DepartmentDefinition = {
  id: "sales",
  name: "Sales",
  gridLabel: "Sales Grid",
  metrics: pickMetrics("calls", "meetings", "opps", "sales"),
  exploreMetrics: pickMetrics("connectedCalls", "callsTotal", "meetings", "opps", "sales"),
  periods: pickPeriods("wtd", "lastWeek", "mtd", "qtd"),
  combineRegions: true,
  thresholds: SALES_THRESHOLDS,
  showRanking: true,
  rankingCount: 3,
  periodWeights: SALES_PERIOD_WEIGHTS,
};
